import { render, staticRenderFns } from "./CustomerSelectAdd.vue?vue&type=template&id=1b6a3f1b&"
import script from "./CustomerSelectAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerSelectAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelectAdd.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports